import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';
import { disabledBehavior } from '../Shared/ButtonDisabledBehavior.styled';
import { overlayInteraction } from '../Shared/ButtonOverlay.styled';

export const LoginRequiredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 16px 56px 16px;
  text-align: center;
  gap: 12px;
  color: ${(props) => props.theme.color.chatPanel};
`;

export const LoginIcon = styled.svg`
  width: 40px;
  height: 40px;
`;

export const LoginTitle = styled.h3`
  margin: 0;
  font-size: ${(props) => props.theme.font.size.large};
  font-weight: ${(props) => props.theme.font.weight.semiBold};
`;

export const LoginMessage = styled.p`
  margin: 0;
  font-size: ${(props) => props.theme.font.size.small};
`;

export const LoginButton = styled.a`
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  background-color: ${(props) => props.theme.color.chatPanel};
  color: ${(props) => props.theme.color.chatPanelBG};
  font-size: ${(props) => props.theme.font.size.default};
  font-weight: ${(props) => props.theme.font.weight.medium};
  text-decoration: none;
  margin-top: 4px;

  ${disabledBehavior()}

  ${overlayInteraction({ isHighlighted: (theme) => !!(theme as IOcAppTheme).color.highlightOnSVG, 
    backgroundColor: (theme) => theme.color.chatPanel })}

  //override link styles
  &:hover, &:focus {
    color: ${(props) => props.theme.color.chatPanelBG};
  }
`;

